<template>
	<div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">
                        
                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="main-body">
                                        <div class="page-wrapper">
                                            <!-- Page body start -->
                                            <div class="page-body">
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <!-- Search result 2 card start -->
                                                        <div class="card">
                                                            <div class="card-block">
                                                                <div class="row">
                                                                    <div class="col-lg-10 offset-lg-1">
                                                                        <div class="page-header-title">
                                                                            <!-- <i class="icofont icofont-stock-search bg-c-yellow"></i> -->
                                                                            <div class="d-inline mt-3">
                                                                                <h4>Search Results</h4>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row search-header">
                                                                    <div class="col-lg-10 offset-lg-1">
                                                                        <form>
                                                                            <div class="input-group input-group-button input-group-primary">
                                                                                <input type="text" class="form-control" placeholder="Search by applicant Name, Email, Phone, Referer, etc" v-model="search_query" v-on:keyup="search">
                                                                            </div>
                                                                            <!-- <div style="/*text-align:center;*/">
                                                                                <button class="btn btn-primary input-group-addon">Search</button>
                                                                            </div> -->
                                                                        </form>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- Search result 2 card end -->
                                                        <h4 class="m-b-20"><b>{{search_results.length}}</b> Results Found</h4>
                                                        <div class="row">
                                                            <!-- Search result found start -->
                                                            <div class="col-lg-12 col-xl-10 search2 search-result">
                                                                <div class="card card-main">
                                                                    <div class="card-block">
                                                                        <div class="row">
                                                                            <div class="col-sm-12">
                                                                                <div v-if="search_results.length > 0">
                                                                                    <div class="search-content" v-for="result in search_results">
                                                                                        <div v-if="result.joblisting !== undefined">
                                                                                            <div class="card-block">
                                                                                                
                                                                                                <h5 class="card-title">
                                                                                                    <a v-bind:href="'/opening/' + result.joblisting[0].id + '/application/' + result.id" target="_blank">
                                                                                                        {{result.firstname + " " + result.lastname}}
                                                                                                    </a>
                                                                                                </h5>
                                                                                                <p class="card-text text-muted">
                                                                                                    <b>Applied for: </b> <a v-bind:href="'/opening/' + result.joblisting[0].id">{{result.joblisting[0].name}}</a>
                                                                                                </p>
                                                                                                <p class="card-text text-muted">
                                                                                                    <b>Currently in stage:</b> {{result.stage.stage_id}}
                                                                                                </p>
                                                                                                <p class="card-text text-muted">
                                                                                                    <b>Email Address:</b> {{result.emailaddress}}
                                                                                                </p>
                                                                                                <p class="card-text"><small class="text-muted">Last updated at {{result.updated_at}}</small></p>
                                                                                            </div>
                                                                                        </div>
                                                                                        
                                                                                    </div>
                                                                                </div>
                                                                                    
                                                                                <div v-else>
                                                                                    <span v-html="search_status"></span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Page body end -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navbar1 from '../components/Navbar1.vue'
import navbar2 from '../components/Navbar2.vue'

export default {
    name: 'SearchResults',

    data(){
        return{
            search_query: '',
            search_results: [],
            search_status: '<img src="../assets/loader.gif">'
        }
    },

    components:{
        navbar1,
        navbar2
    },

    mounted(){
        if(this.$route.query.q !== 'undefined'){
            this.search_query = this.$route.query.q

            this.search()
        }
    },
    methods: {
        search: function(){

            this.search_results = []

            this.search_status = '<img src="/loader.gif" />'

            let request = {
                what: 'SearchResults',
                params:{
                    query: this.search_query
                },
                showLoader: false
            }

            this.$socket.makeGetRequest(request)
                .then((response)=>{
                    if(response.type == "SearchResults"){
                        this.search_results = response.data
                        if(response.data.length < 1){
                            this.search_status = '<b class="p-4">No results found for your query.</b>'
                        }
                    }
                })
                .catch((error)=>{
                    this.search_status = '<b class="p-4">No results found for your query.</b>'
                    //console.log(error)
                })
        }
    },
    computed: {
        
    }
}
</script>
